<ng-content></ng-content>
<ng-template ngFor [ngForOf]="displayedAreas" let-area="$implicit" let-index="index" let-last="last">
     
    <div role="slider"
         tabindex="0"
         *ngIf="last === false"
         #gutterEls
         class="as-split-gutter mat-divider mat-toolbar mat-secondary"
         [style.flex-basis.px]="gutterSize"
         [style.order]="index * 2 + 1"
         (pointerdown)="startMouseDrag($event, index * 2 + 1, index + 1)"
         (touchstart)="startMouseDrag($event, index * 2 + 1, index + 1, true)"
         (pointerup)="endMouseDrag($event, index + 1)"
         (touchend)="endMouseDrag($event, index + 1)"
         [attr.aria-label]="gutterAriaLabel"
         [attr.aria-orientation]="direction"
         [attr.aria-valuemin]="area.minSize"
         [attr.aria-valuemax]="area.maxSize"
         [attr.aria-valuenow]="area.size"
         [attr.aria-valuetext]="getAriaAreaSizeText(area.size)">
        <div class="as-splitter-handle"></div>
        <div class="as-splitter-expander"></div>
        <div class="spliter-icon-box mat-toolbar mat-secondary" *ngIf="isEdit">
            <mat-icon (pointerup)="add($event, index + 1)" class="spliter-add mat-secondary cursor-hand">add_circle_outline</mat-icon>
        </div>
    </div>
</ng-template>
